import React from 'react';
import PropTypes from 'prop-types';

import { Grid } from '@material-ui/core';

const Header = ({ children, ...props }) => {
  return (
    <Grid container {...props}>
      {children}
    </Grid>
  );
};

Header.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  // TODO: make it known that all "Grid" propTypes are available here
};

Header.defaultProps = {
  alignItems: 'center',
  justify: 'space-between',
};

export default Header;
